module.exports = App.OrderContentEditItemComponent = Em.Component.extend
  classNames: [ 'order-line' ]

  # Сохраняется
  isItemSaving: false

  # Флаг приходит сверху
  canEdit:      false

  manualEditing: false

  amountEditValue: Em.computed.oneWay('item.amount')

  isMetric: Em.computed.oneWay('item.metric')

  itemDeltaQty: Em.computed.oneWay('item.delta_qty')

  itemMinQty: Em.computed.oneWay('item.min_qty')

  showDishPhotoInOrderCard: localStorage.getItem('showDishPhotoInOrderCard') == 'true'

  unitOfMeasure: (->
    unit = @get('item.weight_unit')
    if @get('item.amount') >= 1000
      return 'liter' if unit == 'milliliter'
      return 'kilogram' if unit == 'gram'
    unit
  ).property('item.amount')

  formattedAmmount: (->
    wightUnit = @get('unitOfMeasure')
    amount = if @get('item.amount') >= 1000 then @get('item.amount') / 1000 else @get('item.amount')
    unless @get('isMetric') then "×#{amount}" else "#{amount}#{Em.I18n.t('draft_dish.weight_units_short.' + wightUnit)}"
  ).property('isMetric','item.amount')


  showAmountPicker: Em.computed(
    'manualEditing',
    'canEdit', ->
      @get('manualEditing') and @get('canEdit')
    )

  editAllowed: (->
    @get('canEdit') and !@get('isItemSaving') and !@get('item.is_bonus')
  ).property(
    'canEdit',
    'isItemSaving',
    'item.is_bonus' )

  actions:
    cancelManualEdit: ->
      @set('amountEditValue', @get('item.amount'))
      @set('manualEditing', false)
      false

    acceptManualEdit: ->
      value = parseInt( @get('amountEditValue') )
      item = @get('item')

      if value && value > 0 && value != item.get('amount')
        item.set('amount', value)

        @set('isItemSaving', true)
        item.save()
        .then =>
          @sendAction('onContentChanged')
          @set('isItemSaving', false)

      @set('amountEditValue', @get('item.amount'))
      @set('manualEditing', false)
      false

    startManualEdit: ->
      return if !@get('editAllowed')
      @set('manualEditing', true)
      false

    editConfiguration: (item) ->
      return unless @get('editAllowed')
      return if !item.get('config')

      @sendAction('onChangeConfiguration', item)
      false

    # ---
    # Удалить блюдо из списка
    # ---
    removeItem: (buddy, item) ->
      return unless @get('editAllowed')
      # todo i18n
      return unless confirm 'Удалить позицию?'

      @sendAction('onItemRemove', item)
      false

    # ---
    # Увеличить/уменьшить количество
    # ---
    decrementItem: (buddy, item) ->
      return unless @get('editAllowed')

      shouldDecrement = if @get('isMetric') then item.get('amount') > @get('itemMinQty') else item.get('amount') > 1

      if shouldDecrement
        item.decrementProperty('amount', if @get('isMetric') then @get('itemDeltaQty') else 1)

        @set('isItemSaving', true)
        item.save().then =>
          @sendAction('onContentChanged')
          @set('isItemSaving', false)
      else
        @send('removeItem', buddy, item)

      false

    incrementItem: (buddy, item) ->
      return unless @get('editAllowed')

      @set('isItemSaving', true)
      item.incrementProperty('amount', if @get('isMetric') then @get('itemDeltaQty') else 1)
      item.save()
      .then =>
        @sendAction('onContentChanged')
        @set('isItemSaving', false)
      false